import { useTranslation } from "react-i18next";
import styles from "./styles.module.css";
import { FaCheckCircle } from "react-icons/fa";
import { Element } from "react-scroll";
import { isRTL } from 'src/utils/global';
import { Title } from "src/components";

const WhyChooseUs = () => {
  const { t } = useTranslation("home");

  // تم تحديث المفاتيح هنا لتطابق نشاط الرخام والجرانيت
  const reasons = [
    t("why_us.items.premium_quality"),
    t("why_us.items.cutting_precision"),
    t("why_us.items.skilled_artisans"),
    t("why_us.items.competitive_prices"),
    t("why_us.items.on_time_delivery"),
  ];

  return (
    <Element name="whyUs" className={`${styles.whyUs} ${isRTL() && styles.rtl}`}>
      <div className="container">
        {/* العنوان المحدث */}
        <Title lgTitle={t("why_us.title")} smTitle={t("why_us.sub_title")} />
        <div className="row justify-content-center">
          <div className={`col-lg-8 ${styles.itemsCon}`}>
            <ul className={styles.list}
              data-aos="fade-up"
              data-aos-anchor-placement="top-bottom"
              data-aos-delay="100"
            >
              {reasons.map((item, index) => (
                <li key={index} className={styles.listItem}>
                  {/* أيقونة بلون ذهبي في الـ CSS ستعطي طابعاً فخماً */}
                  <FaCheckCircle className={styles.icon} />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </Element>
  );
};

export default WhyChooseUs;